import { configureStore } from '@reduxjs/toolkit';
import appReducer from '../redux/appSlice';
import bulkBookingReducer from '../redux/bulkBookingSlice';
import shipperAdviceReducer from '../redux/shipperAdviceSlice';
import addressLabelReducer from '../redux/addressLabelSlice';
import loadSheetReducer from '../redux/loadSheetSlice';
import searchLoadSheetReducer from '../redux/seachLoadSheetSlice';
import darazBulkBookingReducer from './darazBulkBookingSlice';
import darazLoadsheetReducer from './darazLoadsheetSlice';
import mapICCICReducer from '../redux/mapICCICSlice';

const Store = configureStore({
    reducer: {
        appData: appReducer,
        bulkBookingData: bulkBookingReducer,
        shipperAdviceData: shipperAdviceReducer,
        addressLabelData: addressLabelReducer,
        loadSheetData: loadSheetReducer,
        searchLoadSheetData: searchLoadSheetReducer,
        darazBulkBookingData: darazBulkBookingReducer,
        darazLoadSheetData: darazLoadsheetReducer,
        MapICCIDData: mapICCICReducer,
    }
});

export default Store;